export default "__VITE_ASSET__CCCJPz0q__"